<template>
  <div id="page-notices" class="content animate-panel">
    <h2 class="m-n">お知らせ</h2>
    <div class="hpanel" v-if="pageData.length > 0">
      <div class="panel-body" id="notices">
        <div class="hpanel panel-group" id="accordion" role="tablist" aria-multiselectable="true">
          <div class="panel-body" v-for="(notice, index) in pageData" :key="index" :id="`panel-notice-${notice.id}`">
            <div data-toggle="collapse" data-parent="#accordion" :data-target="`#collapse-notice-${notice.id}`" aria-expanded="false" class="collapsed pointer-cursor accordion-title" @click="handleCollapseNotice(notice)">
              <div>
                <p>
                  {{notice.date}}
                  <span v-if="!notice.is_notice_read" class="notice_read_flg">未読</span>
                </p>
                <div v-html="replaceHTMLSellerInfo(notice.title)"></div>
              </div>
              <i class="fa fa-chevron-down text-muted accordion-arrow"></i>
            </div>
            <div :id="`collapse-notice-${notice.id}`" class="panel-collapse collapse" aria-expanded="false">
              <hr>
              <p class="m-l" v-html="replaceHTMLSellerInfo(notice.content)"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <pagination
        :url="'Notice'"
        @onChangePage="onChangePage"
      />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/PaginationLoadMore'
import NoticeService from '@/services/noticeservice'
import store from '@/store'
import LoadingBlock from '@/components/LoadingBlock'
import { replaceHTMLSellerInfo } from '@/common/utility'

export default {
  components: {
    Pagination,
    LoadingBlock
  },
  data () {
    return {
      pageData: [],
      loader: null
    }
  },
  methods: {
    replaceHTMLSellerInfo,
    onChangePage (data) {
      this.pageData = [...data]
    },
    handleScrollToNotice () {
      let route = this.$route
      let routeName = route.name
      let noticeId = route.query.scroll_to || null
      if (routeName === 'Notices' && (!noticeId || noticeId === 'top')) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      } else if (noticeId) {
        setTimeout(() => {
          let elementId = `panel-notice-${noticeId}`
          const element = document.getElementById(elementId)
          if (element) {
            let notice = this.$store.state.notice.notices.find(item => item.id === parseInt(noticeId))

            let collapseNoticeSelector = $(`#collapse-notice-${noticeId}`)
            collapseNoticeSelector.attr('aria-expanded', true)
            collapseNoticeSelector.addClass('in')
            $(`#panel-notice-${noticeId} .accordion-title`).attr('aria-expanded', true)

            this.handleCollapseNotice(notice)
            window.scroll({
              top: (element.getBoundingClientRect().top + window.scrollY) - 70,
              behavior: 'smooth'
            })
          }
        }, 600)
      }
    },
    handleCollapseNotice (notice) {
      if (!notice || notice === null || notice === undefined || notice.is_notice_read) {
        return
      }
      let collapseNoticeSelector = $(`#collapse-notice-${notice.id}`)
      setTimeout(() => {
        if (collapseNoticeSelector.hasClass('in')) {
          this.loader = this.$loading.show()
          NoticeService.addNoticeRead({
            notice_id: notice.id
          })
            .then(response => {
              if (Object.keys(response.data).length) {
                let currentCountNoticeUnread = store.state.notice.countNoticeUnread
                store.commit('setCountNoticeUnread', (currentCountNoticeUnread - 1))
              }
              store.commit('setNoticeStatusRead', notice)
              this.pageData.filter((pageDataItem) => {
                if (pageDataItem.id === notice.id) {
                  pageDataItem.is_notice_read = true
                }
              })
              this.loader && this.loader.hide()
            })
            .catch(err => {
              this.$store.commit('toggleModal', {
                show: true,
                message: err
              })
              this.loader && this.loader.hide()
            })
        }
      }, 400)
    }
  },
  watch: {
    $route (routeValue) {
      this.handleScrollToNotice()
    }
  },
  mounted () {
    this.$events.listen('done', (url) => {
      if (url === 'Notice') {
        this.handleScrollToNotice()
      }
    })
  },
  beforeDestroy () {
    this.$events.remove('done')
    this.loader && this.loader.hide()
  }
}
</script>
<style scoped>
.notice_read_flg {
  background-color: #008cc6;
  color: #fff;
  font-weight: 800;
  border-radius: 5px;
  padding: 0px 10px;
  margin-left: 10px;
}
#page-notices .hpanel {
  margin-bottom: 0px !important;
}
#page-notices #accordion .panel-body:hover {
  background-color: #f7f9fa;
}
</style>



// WEBPACK FOOTER //
// src/view/Notices.vue